import React, {memo} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {IconAccount} from "components/icons";

const AccountsSettings = memo(({settings, onUpdate}) => {
  const {t} = useTranslation();

  return (
    <div className="organization-settings mb-12">
      <SubHeading title="ACCOUNTS" icon={<IconAccount />} />
      <div className="mt-2">
        <i>{t("ACCOUNTS_SWITCH_DESCRIPTION")}</i>
      </div>
      <div className="df-row-center mt-4">
        <CustomRadioSwitch
          checked={settings?.allowProcurementAccount}
          mediumText
          label={t("ACCOUNTS_SWITCH_LABEL")}
          small
          informationText="ACCOUNTS_SWITCH_TOOLTIP"
          isActive={(checked) => onUpdate({allowProcurementAccount: checked})}
        />
      </div>
    </div>
  );
});

export default AccountsSettings;
